import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiPost, operationsClient } from '@/lib/api';
import { leadEndpoints } from '@/lib/api/endpoints';
import { leadKeys } from '@/lib/queryKeys';
import { useApiMutation } from '../useApiMutation';
import type { AssignLeadDto, Lead } from '@/types/lead';

export function useAssignLead() {
  const queryClient = useQueryClient();

  return useApiMutation<Lead, { leadId: string } & AssignLeadDto>({
    mutationFn: ({ leadId, ...dto }) =>
      apiPost<Lead, AssignLeadDto>(operationsClient, leadEndpoints.assign(leadId), dto),
    onSuccess: (data, { leadId }) => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.detail(leadId) });
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Lead assigned');
    },
  });
}
